<template>
  <div class="bfms-portal bfms-employee" :class="{ 'bfms-auth-page': !showDashboardSidenav }">
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start',
    ]"
    v-if="showDashboardSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
    :style="this.$store.state.isRTL ? 'overflow-x: hidden' : ''"
  >
    <!-- Dashboard shell only: never mount Navbars/Navbar (Breadcrumbs) on auth pages -->
    <navbar
      :class="[navClasses]"
      :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="navbarMinimize"
      v-if="showDashboardNavbar"
    />
    <div class="bfms-page-content"><router-view /></div>
    <!-- <app-footer v-show="this.$store.state.showFooter" /> -->
    <configurator
      v-if="showAppConfigurator"
      :toggle="toggleConfigurator"
      :class="[this.$store.state.showConfig ? 'show' : '']"
    />
  </main>
  <mobile-navigation v-if="showDashboardSidenav" portal="employee" />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import MobileNavigation from "./components/MobileNavigation.vue";
import "./assets/css/mobile.css";
// import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import { isPublicAuthPath } from "@/utils/publicAuthRoutes";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    MobileNavigation,
    // AppFooter,
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
  computed: {
    /** Blocks dashboard Navbars/Navbar.vue + Breadcrumbs on /sign-in, etc. (avoids first-paint race with Vuex defaults). */
    showDashboardNavbar() {
      if (isPublicAuthPath(this.$route.path)) return false;
      return this.$store.state.showNavbar;
    },
    showDashboardSidenav() {
      if (isPublicAuthPath(this.$route.path)) return false;
      return this.$store.state.showSidenav;
    },
    showAppConfigurator() {
      if (isPublicAuthPath(this.$route.path)) return false;
      return !this.$store.state.hideConfigButton;
    },
    navClasses() {
      return {
        "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky": this
          .$store.state.isNavFixed,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
      };
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
};
</script>
